<template>
    <div >

        <div class=" overflow-hidden sm:rounded-md" v-if="showData()">

            <div class="pl-4 py-4 flex gap-4">

                <div class="flex gap-1 text-xs items-center">
                    <div class="bg-indigo-600 p-1 rounded-full"></div> Workspaces
                </div>

                <div class="flex gap-1 text-xs items-center">
                    <div class="bg-lime-600 p-1 rounded-full"></div> Departaments
                </div>

                <div class="flex gap-1 text-xs items-center">
                    <div class="bg-amber-600 p-1 rounded-full"></div> Users
                </div>


            </div>
            
            <ul role="list" class="divide-y ">
                <li v-for="row in dataRows" :key="row.id">
                    <div href="#" class="block " :class="(searchSelected(row.id)) ? 'isSelected' : 'hover:bg-gray-50' "  >
                        <div class="px-4 py-4 flex items-center sm:px-6 group relative" >

                            <div v-if="buttons && buttons.length > 0" class="absolute hidden right-0 group-hover:flex pr-2 justify-end gap-2">
                                <button v-for="button in buttons" :key="button.name" :class="button.class" class="flex items-center gap-2" @click="button.action(row)">
                                    <div v-if="button.icon">
                                        <component :is="button.icon" class="h-5 w-5"/>                                    
                                    </div>
                                    <div v-if="button.name">
                                        {{button.name}}
                                    </div>
                                </button>
                            </div>

                            
                            <div v-if=(row.new) class="mr-2">
                                <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-cyan-800 text-white">
                                    New
                                </span>
                            </div>    

                            <div class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between cursor-pointer "  @click="$emit('open:item', $event, row)">
                                <div class="truncate w-full">
                                    
                                    <div class="truncate" :class="(searchSelected(row.id)) ? 'text-white' : 'text-indigo-600' ">


                                        <div class="flex items-center">
                                            <div class="w-full">
                                                <div class="font-thin truncate text-[10px]" v-if="row.code">code: {{row.code}}</div>

                                                
                                                <div class="font-medium truncate flex items-center">

                                                    <span v-if="row.nivel">{{nivel(row.nivel)}}</span>
                
                                                    <div v-if="row.privacy && row.privacy == 'private'">
                                                        <LockClosedIcon class="h-4 pr-1"/>
                                                    </div>
                                                
                                                    <div v-if="row.color" class="pl-1 pr-2">
                                                        <div class="h-3 w-3 rounded-full ring-2 ring-offset-2 ring-offset-gray-100" :class="row.color"></div>
                                                    </div>

                                                    <div v-if="row.avatar" class="pr-2">
                                                        <img class="h-8 w-8 rounded-full" :src="row.avatar" alt="">
                                                    </div>

                                                    <div v-if="row.workspaces && row.workspaces.name && !row.type" class="pr-1">{{row.workspaces.name}} ➜ </div>

                                                    <div v-if="row.name" class="flex items-center gap-2">
                                                        {{ row.name }}
                                                        <div v-if="row.status" class="text-xs">
                                                            <div v-if="row.status == 'active'" class="text-white bg-lime-600 rounded-full px-2">Ativo</div>
                                                            <div v-if="row.status == 'inative'" class="text-white bg-rose-600 rounded-full px-2">Inativo</div>                                                    
                                                        </div>
                                                    </div>
                                                    
                                                    
                                                </div>
                                                
                                            </div>


                                        </div>
                                    </div>

                                    <div v-if="row.email" class="text-sm">{{ row.email }}</div>

                                </div>

                                <div class="mt-4 flex-shrink-0 sm:mt-0 sm:ml-5 flex ">
                                    <div class="rounded-full bg-indigo-600 px-3 text-white">
                                        {{row.workspaces.length}}
                                    </div>
                                </div>

                                <div class="mt-4 flex-shrink-0 sm:mt-0 sm:ml-5 flex">
                                    <div class="rounded-full bg-lime-600 px-3 text-white">
                                        {{row.departaments.length}}
                                    </div>
                                </div>

                                <div class="mt-4 flex-shrink-0 sm:mt-0 sm:ml-5 flex">
                                    <div class="rounded-full bg-amber-600 px-3 text-white">
                                        {{row.users.length}}
                                    </div>
                                </div>
                            </div>

                            <div class="ml-5 flex-shrink-0">
                                <ChevronRightIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                            </div>
                            
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div v-else>
            
                <noData/>
            
        </div>
    </div>
</template>

<script type="javascript">

import { ChevronRightIcon, LockClosedIcon, QuestionMarkCircleIcon  } from '@heroicons/vue/24/solid'




export default {
    name: "ListOptionsUsers",
    props: {
        count: {
            type: Number,
            required: false,
        },
        buttons: {
            type: Array,
            required: false,
        },
        dataRows: {
            type: Object,
            required: false
        },
        selected: {
            type: Array,
            required: false
        },
        integration: {
            type: Function,
            required: false
        },
        type: {
            type: String,
            required: false
        },
    },
    emits: ['open:item'],
    
    components: {        
        ChevronRightIcon,
        LockClosedIcon,
        QuestionMarkCircleIcon,
    },
    methods: {

        showData(){
            try{
                if(this.dataRows.length){
                    return true;
                }
                return false 
            } catch(e){
                return false;
            }          
        },
        processAttribute(key, attribute) {
            return this.$Attributs.process(key, attribute); 
        },
        searchSelected(id) {        
            return this.selected.indexOf(id) > -1;
        },
        nivel(nivel){
            let seta = '├';
            if(nivel && nivel > 0){                
                for(let i = 1; i <= nivel; i++){
                    seta = seta + '─';
                }
                seta = seta+'›';
            }
            else {
                seta = '•';
            }
            return seta            
        }  
    },
    created(){
        
    },
    
}


</script>

<style scoped>
.isSelected {
    @apply bg-indigo-600;
}

</style>